export { default } from './InputPassword';
